<template lang="pug">
  div.observer
</template>

<script>
export default {
  name: 'observer',
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry && entry.isIntersecting) {
        this.$emit('intersecting')
      }
    });

    this.observer.observe(this.$el);
  },

}
</script>

<style lang="scss" scoped>
.observer {
  width: 100%;
  height: 20px;
}
</style>
